require('./bootstrap');

const ClickTracker = {
    registerClick: function (trackInfo) {
        fetch('/api/track-click', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            },
            body: JSON.stringify({
                track_name: trackInfo
            })
        })
            .then(response => {
                if (!response.ok) {
                    console.error('Error tracking click:', response.statusText);
                }
            })
            .catch(error => {
                console.error('Error tracking click:', error);
            });
    }
};

document.addEventListener('click', function (e) {
    const trackElement = e.target.closest('.click-track');
    if (trackElement) {
        const trackInfo = trackElement.getAttribute('data-info-click');
        if (trackInfo) {
            ClickTracker.registerClick(trackInfo);
        }
    }
});
